export default __webpack_public_path__ + "static/media/logoLight.33708089.png";